<div class="space-y-8 animate-fade-in-up font-sans">

  <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 relative overflow-hidden">
    <div class="absolute left-0 top-0 bottom-0 w-1 bg-[#1e3a8a]"></div>

    <div class="flex items-center gap-4">
      <div class="bg-blue-50 p-3 rounded-xl text-[#1e3a8a] shadow-inner">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
      </div>
      <div>
        <h2 class="text-2xl font-black text-[#1e3a8a] tracking-wide uppercase">Gestión Humana y SST</h2>
        <p class="text-xs text-gray-500 font-medium mt-1">Talento, seguridad y salud en el trabajo</p>
      </div>
    </div>

    <div class="flex flex-wrap gap-3 w-full md:w-auto">
      <button class="flex-1 md:flex-none flex items-center justify-center gap-2 bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-xl shadow-sm hover:bg-gray-50 hover:border-gray-300 transition-all text-sm font-bold group">
        <svg class="w-4 h-4 text-gray-400 group-hover:text-[#1e3a8a]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
        Reporte SST
      </button>
      <button class="flex-1 md:flex-none flex items-center justify-center gap-2 bg-[#1e3a8a] hover:bg-[#ffb31c] text-white hover:text-[#1e3a8a] px-5 py-2.5 rounded-xl shadow-md transition-all text-sm font-bold group">
        <svg class="w-4 h-4 transform group-hover:rotate-12 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
        Registrar Incidente
      </button>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between group hover:shadow-md transition-shadow relative overflow-hidden">
      <div class="absolute right-0 top-0 w-1.5 h-full bg-[#1e3a8a]"></div>
      <div class="relative z-10">
        <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-1">Fuerza Laboral</p>
        <h3 class="text-4xl font-black text-[#1e3a8a] tracking-tight">{{ totalEmpleados }}</h3>
        <p class="text-[10px] text-gray-500 font-bold mt-2">Personal Activo</p>
      </div>
      <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center text-[#1e3a8a] group-hover:scale-110 transition-transform shadow-inner ring-4 ring-white">
        <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>
      </div>
    </div>

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between group hover:shadow-md transition-shadow relative overflow-hidden">
      <div class="absolute right-0 top-0 w-1.5 h-full bg-gray-400"></div>
      <div class="relative z-10">
        <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-1">Ausentismo Mensual</p>
        <h3 class="text-4xl font-black text-gray-700 tracking-tight">{{ indiceAusentismo }}</h3>
        <p class="text-[10px] text-gray-500 font-bold mt-2">Índice global</p>
      </div>
      <div class="w-14 h-14 bg-gray-50 rounded-full flex items-center justify-center text-gray-500 group-hover:scale-110 transition-transform shadow-inner ring-4 ring-white">
        <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"></path></svg>
      </div>
    </div>

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between group hover:shadow-md transition-shadow relative overflow-hidden">
      <div class="absolute right-0 top-0 w-1.5 h-full bg-[#ffb31c]"></div>
      <div class="relative z-10">
        <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-1">Cursos Pendientes</p>
        <h3 class="text-4xl font-black text-[#ffb31c] tracking-tight">{{ capacitacionesPendientes }}</h3>
        <p class="text-[10px] text-gray-500 font-bold mt-2">Programación SST</p>
      </div>
      <div class="w-14 h-14 bg-yellow-50 rounded-full flex items-center justify-center text-[#ffb31c] group-hover:scale-110 transition-transform shadow-inner ring-4 ring-white">
        <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path></svg>
      </div>
    </div>

    <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between group hover:shadow-md transition-shadow relative overflow-hidden">
      <div class="absolute right-0 top-0 w-1.5 h-full bg-red-500"></div>
      <div class="relative z-10">
        <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-1">Incidentes Activos</p>
        <h3 class="text-4xl font-black text-red-600 tracking-tight">{{ incidentesActivos }}</h3>
        <p class="text-[10px] text-red-400 font-bold mt-2 flex items-center gap-1">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
          Requiere atención
        </p>
      </div>
      <div class="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center text-red-500 group-hover:scale-110 transition-transform shadow-inner ring-4 ring-white">
        <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path></svg>
      </div>
    </div>

  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">

    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 lg:col-span-2 overflow-hidden flex flex-col h-[500px]">

      <div class="p-5 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
        <h3 class="text-sm font-black text-[#1e3a8a] uppercase tracking-wide flex items-center gap-2">
          <svg class="w-4 h-4 text-[#ffb31c]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
          Cronograma Capacitaciones SST
        </h3>
        <button class="text-xs font-bold text-[#1e3a8a] hover:text-[#ffb31c] transition-colors flex items-center gap-1 bg-white border border-gray-200 px-3 py-1.5 rounded-lg shadow-sm hover:bg-gray-50">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
          Ver Calendario
        </button>
      </div>

      <div class="overflow-y-auto flex-1 custom-scrollbar">
        <table class="w-full text-sm text-left whitespace-nowrap">
          <thead class="bg-white text-gray-400 text-[10px] uppercase font-black tracking-widest border-b border-gray-100 sticky top-0 z-10 shadow-sm">
            <tr>
              <th class="px-6 py-4">Tema / Módulo</th>
              <th class="px-6 py-4">Fecha</th>
              <th class="px-6 py-4">Modalidad</th>
              <th class="px-6 py-4 text-center">Estado</th>
            </tr>
          </thead>
          <tbody class="text-gray-600 divide-y divide-gray-50">
            @for (c of capacitaciones; track c.tema) {
              <tr class="hover:bg-blue-50/50 transition-colors group">
                <td class="px-6 py-4 font-bold text-gray-800 group-hover:text-[#1e3a8a] transition-colors flex items-center gap-3">
                  <div class="w-2 h-2 rounded-full" [class.bg-blue-400]="c.estado === 'Programada'" [class.bg-green-400]="c.estado === 'Completada'"></div>
                  {{ c.tema }}
                </td>
                <td class="px-6 py-4 font-medium text-gray-500">{{ c.fecha | date:'dd MMM, yyyy' }}</td>
                <td class="px-6 py-4">
                  <span class="text-xs bg-gray-100 text-gray-600 px-2.5 py-1 rounded-md font-medium border border-gray-200">
                    {{ c.modalidad }}
                  </span>
                </td>
                <td class="px-6 py-4 text-center">
                  <span class="px-2.5 py-1.5 rounded-md text-[10px] font-black uppercase tracking-wider shadow-sm border"
                        [class.bg-blue-50]="c.estado === 'Programada'" [class.text-blue-700]="c.estado === 'Programada'" [class.border-blue-200]="c.estado === 'Programada'"
                        [class.bg-green-50]="c.estado === 'Completada'" [class.text-green-700]="c.estado === 'Completada'" [class.border-green-200]="c.estado === 'Completada'">
                    {{ c.estado }}
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 lg:col-span-1 overflow-hidden flex flex-col h-[500px]">

      <div class="p-5 border-b border-gray-100 bg-gray-50">
        <h3 class="text-sm font-black text-red-600 uppercase tracking-wide flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
          Alertas SST
        </h3>
      </div>

      <div class="overflow-y-auto flex-1 p-5 bg-gray-50/30 custom-scrollbar">
        <div class="space-y-4">
          @for (a of alertas; track a.descripcion) {
            <div class="p-4 bg-white border border-gray-100 rounded-xl shadow-sm hover:shadow-md transition-all border-l-4 relative overflow-hidden group"
                 [class.border-l-red-500]="a.nivel === 'Alto'"
                 [class.border-l-[#ffb31c]]="a.nivel === 'Medio'"
                 [class.border-l-green-500]="a.nivel === 'Bajo'">

              <svg class="absolute -right-2 -bottom-2 w-16 h-16 opacity-5 group-hover:scale-110 transition-transform"
                   [class.text-red-500]="a.nivel === 'Alto'" [class.text-[#ffb31c]]="a.nivel === 'Medio'" [class.text-green-500]="a.nivel === 'Bajo'"
                   fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>

              <div class="relative z-10">
                <div class="flex justify-between items-start mb-2">
                  <span class="text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-md"
                        [class.bg-red-50]="a.nivel === 'Alto'" [class.text-red-700]="a.nivel === 'Alto'"
                        [class.bg-yellow-50]="a.nivel === 'Medio'" [class.text-yellow-700]="a.nivel === 'Medio'"
                        [class.bg-green-50]="a.nivel === 'Bajo'" [class.text-green-700]="a.nivel === 'Bajo'">
                    {{ a.tipo }}
                  </span>
                  <span class="text-[10px] font-bold text-gray-400 flex items-center gap-1">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    {{ a.fecha | date:'dd MMM' }}
                  </span>
                </div>
                <p class="text-sm font-bold text-gray-800 leading-snug group-hover:text-[#1e3a8a] transition-colors">{{ a.descripcion }}</p>
              </div>

            </div>
          }
        </div>
      </div>

    </div>
  </div>
</div>
